export default __webpack_public_path__ + "static/media/10-antonas.98458a1f.jpg";